module.exports = __webpack_public_path__ + "images/emoji/fish.eac64c8794d1a9403cab.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/fish.png
// module id = t16C
// module chunks = 2